import { useRouter } from "next/router"
import { isPageRoute, RouteKey, useRoutes } from "src/hooks/useRoutes"
import { useRouteLink } from "src/utilities/routesContext"
import { windowWrapper } from "src/utilities/windowWrapper"
import { useCallback } from "react"

export type NavigateTo = ReturnType<typeof useNavigateTo>

export const useNavigateTo = () => {
  const router = useRouter()
  const routeLink = useRouteLink()
  const getRoute = useRoutes()
  return useCallback(
    (routeKey: RouteKey | string, replace = false) => {
      if (isPageRoute(routeKey)) {
        const rewrittenPath = routeLink(routeKey)
        if (replace) {
          router.replace(rewrittenPath, undefined, { locale: false })
        } else {
          router.push(rewrittenPath, undefined, { locale: false })
        }
      } else {
        const path =
          typeof routeKey === "string" ? routeKey : getRoute(routeKey)
        windowWrapper.href = path
      }
    },
    [getRoute, router, routeLink],
  )
}
